<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">تعديل الخبر</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="updateSelectedPost">
              <div class="card-body__form">
                <div class="row">
                  <!-- Post Data -->
                  <div class="col-lg-8">
                    <!-- Post Title -->
                    <div class="form-group">
                      <label for="postTitle">العنوان</label>
                      <input
                        type="text"
                        class="form-control"
                        id="postTitle"
                        placeholder="العنوان"
                        required
                        v-model="post.title"
                      />
                    </div>
                    <!-- Short Description -->
                    <div class="form-group">
                      <label for="title">وصف قصير</label>
                      <textarea
                        class="form-control"
                        placeholder="وصف قصير"
                        id="title"
                        cols="30"
                        required
                        maxlength="260"
                        v-model="post.short_description"
                        rows="6"
                      ></textarea>
                    </div>
                    <!-- Post Type -->
                    <div class="form-group">
                      <label for="post_type">نوع الخبر</label>
                      <select
                        class="form-control form-select"
                        aria-label="Default select"
                        id="post_type"
                        v-model="post.post_type"
                      >
                        <option :value="1">نص</option>
                        <option :value="2">صورة</option>
                        <option :value="3">ملف</option>
                        <option :value="4">فيديو</option>
                      </select>
                    </div>
                  </div>
                  <!-- Post Image -->
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-12 mt-2">
                        <div class="from-group">
                          <label for="">تغير صورة الخبر</label>
                          <UploadImages
                            class="form-control"
                            @changed="handleImages"
                            :max="1"
                            maxError="يمكنك رفع صورة واحدة لكل خبر"
                            fileError="لا يمكن رفع ملفات غير الصور"
                          />
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="from-group">
                          <label for="">صورة الخبر الحالية</label>
                          <div
                            data-bs-toggle="modal"
                            data-bs-target="#showImageModal"
                            class="img__have mt-2"
                            v-if="post.thumbnail_url"
                          >
                            <img
                              :src="post.thumbnail_url"
                              class="img-fluid"
                              alt="post image"
                            />

                            <div
                              class="modal fade showImage"
                              id="showImageModal"
                              tabindex="-1"
                              aria-labelledby="showImageModalLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                  <div class="modal-body">
                                    <button
                                      type="button"
                                      class="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>

                                    <img
                                      :src="post.thumbnail_url"
                                      class="img-fluid"
                                      alt="post image"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="img__container mt-2" v-else>
                            <span>لا توجد صورة</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <!-- Post Data Depends Type -->
                    <div class="form-group files">
                      <label for="description">الوصف</label>
                      <!-- Text -->
                      <div
                        v-if="post.post_type == 1"
                        class="editor__design mt-2"
                      >
                        <Editor height="400" v-model="post.description" />
                      </div>
                      <!-- Image -->
                      <div v-if="post.post_type == 2" class="mt-2">
                        <UploadImages
                          class="form-control"
                          @changed="onFileSelect"
                          :max="1"
                          maxError="يمكنك رفع صورة واحدة لكل خبر"
                          fileError="لا يمكن رفع ملفات غير الصور"
                        />
                      </div>
                      <!-- File -->
                      <div v-if="post.post_type == 3" class="mt-2">
                        <!-- Custom Input File -->
                        <div
                          class="dragDrop"
                          @dragover="onDropOver($event)"
                          @dragleave="onDropLeave($event)"
                        >
                          <div v-if="this.file == null" class="dragDrop__input">
                            <div class="dragDrop__input__icon">
                              <i
                                class="fa fa-upload icon"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                          <div v-else class="dragDrop__file">
                            <div class="dragDrop__file__icon">
                              <i class="fa fa-file icon" aria-hidden="true"></i>
                            </div>
                            <div class="dragDrop__file__text">
                              <span>{{ this.file.name }}</span>
                            </div>
                          </div>
                          <input
                            type="file"
                            id="chooseFiles"
                            placeholder="أضف الملف"
                            @change="onFileSelect($event)"
                            accept="application/pdf"
                          />
                        </div>
                        <!-- Custom Input File -->
                      </div>

                      <!-- Video -->
                      <div v-if="post.post_type == 4" class="mt-2">
                        <textarea
                          class="form-control"
                          placeholder="رابط الفيديو"
                          cols="30"
                          rows="5"
                          required
                          v-model="post.file_url"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary">حفظ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// Vuex Store

import { mapActions } from "vuex";

// Upload Image
import UploadImages from "vue-upload-drop-images";
// Editor
import Editor from "@/components/EditorComponent.vue";

import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();

export default {
  data() {
    return {
      post_id: this.$route.params.id,
      thumbnail: null,
      file: null,
      post: {},
    };
  },
  components: {
    Editor,
    UploadImages,
  },
  methods: {
    ...mapActions("postsModule", ["getPostById", "updatePost"]),

    // Add New Post
    async updateSelectedPost() {
      this.uploadThumbnail().then(() => {
        console.log(this.post);
        this.$router.push("/posts");
      });
    },

    async uploadFile() {
      if (this.file !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع الملف الان",
            file: this.file,
            collection: "IMAGEs",
            contentType: this.file.type,
            onFinished: (url) => {
              console.log(url);
              this.post.file_url = url ?? "";
              toast.dismiss(toastId);
              this.updatePost(this.post);
              this.clearAndShowSuccess();
            },
          },
        };
        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.updatePost(this.post);
        this.clearAndShowSuccess();
      }
    },

    // Upload Thumbnail
    async uploadThumbnail() {
      if (this.thumbnail !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع الصورة الان",
            file: this.thumbnail,
            collection: "IMAGEs",
            onFinished: (url) => {
              console.log(url);
              this.post.thumbnail_url = url ?? "";
              toast.dismiss(toastId);
              this.uploadFile();
            },
          },
        };
        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.uploadFile();
        this.clearAndShowSuccess();
      }
    },

    //-----------------------------------------------------//
    // Add thumbnail Post
    handleImages(files) {
      this.thumbnail = files[0];
      console.log(this.thumbnail);
    },
    //-----------------------------------------------------//
    ///// Custom Input File
    // Drop Over Elemet area
    onDropOver($event) {
      let el = $event.currentTarget;
      el.classList.add("drop_zone");
    },
    // Drop Leave Elemet area
    onDropLeave($event) {
      let el = $event.currentTarget;
      el.classList.remove("drop_zone");
    },
    // When Select File
    onFileSelect(e) {
      if (this.post.post_type == 2) {
        this.file = e[0];
      } else if (this.post.post_type == 3) {
        this.file = e.target.files[0];
      }
    },
    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      this.thumbnail = null;
      this.post = {
        title: "",
        thumbnail_url: "",
        short_description: "",
        description: "",
        file_url: "",
        views: 0,
        post_type: 1,
        author: {
          name: null,
          avatar_url: null,
        },
      };
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم تعديل الخبر بنجاح",
      });
    },
    // All Two functions
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    //---------------------//
  },
  async created() {
    this.post = await this.getPostById(this.post_id);
    console.log("post", this.post);
  },
  computed: {},
  mounted() {},
};
</script>
<style>
</style>